// extracted by mini-css-extract-plugin
export default {"container":"style_container__-WqTy","titleFirst":"style_titleFirst__7VxJP","titleSecond":"style_titleSecond__oEvAu"};